import Dialog from '@components/Atoms/Dialog';
import TextField from '@components/Atoms/TextField';
import React, { useState } from 'react';
import Typography from '@components/Atoms/Typography';
import { useExtendTestletSessionTimeMutation } from '../mutations';

type Props = {
  onConfirm: () => void;
  open: boolean;
  onClose: () => void;
  data: {
    studentIds: number[];
    testletId: number;
  };
};

const ExtendTimeConfirmationDialog = ({ onConfirm, open, onClose, data }: Props) => {
  const [extendDuration, setExtendDuration] = useState(0);
  const { mutate: extendTestletSessionTime, isLoading } =
    useExtendTestletSessionTimeMutation(data.testletId);
  return (
    <Dialog
      open={open}
      onClose={() => onClose()}
      title="Extend Time"
      actions={[
        {
          label: 'Cancel',
          onClick: () => {
            onClose();
          },
        },
        {
          label: isLoading ? 'Extending...' : 'Extend Time',
          onClick: () => {
            extendTestletSessionTime(
              { studentIds: data.studentIds, extendDuration },
              {
                onSuccess: () => {
                  onConfirm();
                },
              },
            );
          },
          buttonProps: {
            variant: 'contained',
            color: 'primary',
          },
        },
      ]}
    >
      <Typography>Extend the time for the selected testlet sessions</Typography>
      <TextField
        label="Extend Duration (minutes)"
        value={extendDuration}
        onChange={(e) => setExtendDuration(Number(e.target.value))}
        variant="outlined"
        type="number"
        inputProps={{
          min: 0,
        }}
        sx={{
          width: '100%',
          mt: 2,
        }}
      />
      <Typography sx={{ mt: 2 }}>
        Note: completed testlet sessions will be switched to paused state.
      </Typography>
    </Dialog>
  );
};

export default ExtendTimeConfirmationDialog;
